<template>
    <div class="">
          
        <div class="print-card">

            <div class="print-chart-scroll">
                <div class="">
                
                    <div :id="chartID" class="chart"></div>
                    <!-- <div class="info-datazoom">
                        <span class="info-text">
                            {{ $t('u.time') }}<br>{{ $t('menu.range') }}
                        </span>
                        <span class="info-text">
                            <i class="fa fa-arrow-right"></i>
                        </span>
                    </div> -->

                </div>

                <!-- <div class="print-hide-object">
                    <AgriSpeech :info="'點工作紀錄的彩色圓圈可以看到更詳細的內容喔!'"></AgriSpeech>
                </div> -->

                <b-modal scrollable :size="modalSize" ref="modal"
                        v-model="showModal"
                        @hide="clickedItem = undefined"
                        header-bg-variant="success"
                        :body-bg-variant="'dark'"
                        hide-header-close hide-footer>

                    <template v-if="clickedItem">
                        <template v-if="clickedItem.itemType == 'growth_period'">
                            <template slot="modal-title">
                                {{ clickedItem.data.name[ this.language ] }}
                            </template>
                            <div>
                                <h3>{{ clickedItem.data.name[ this.language ] }}</h3>
                                <h4>{{ clickedItem.data.definition[ this.language ] }}</h4>

                                <hr>

                                <h4>
                                    {{ clickedItem.data.start_date }} - {{ clickedItem.data.end_date }}
                                    ( {{ $tools.date.countDays( clickedItem.data.start_date, clickedItem.data.end_date ) }} {{ $t('u.days') }} )
                                </h4>
                            </div>
                        </template>
                        
                        <template v-if="clickedItem.itemType == 'diary'">
                            <template slot="modal-title">
                                【 {{ clickedItem.data.log_time }} 】　{{ clickedItem.data.action }}
                            </template>
                            <div>
                                <div class="modal-pic"
                                    :alt="clickedItem.data.action"
                                    :style="$tools.style.imgCover( $config.checkURL('photo', clickedItem.data.pic), 'contain' )"
                                ></div>
                                
                                <div class="modal-user-info" v-if="clickedItem.data.type">
                                    <div class="date-time">{{ clickedItem.data.log_time }}</div>
                                    <div class="log-icon">
                                        <div v-html="getLogIcon( clickedItem.data.type )"></div>
                                    </div>
                                    <div class="log-info-block">{{ $t('menu.' + clickedItem.data.type) }}</div>
                                </div>

                                <div class="speech-bubble">
                                
                                    <div v-if="clickedItem.data.description">{{ clickedItem.data.description }}</div>
                                    <div v-else class="text-muted">( {{ $t('menu.no_description') }} )</div>

                                </div>
                            </div>
                        </template>

                    </template>

                    <div class="text-center">
                        <br>
                        <b-button variant="secondary" class="btn btn-upload"
                                @click.prevent="clickedItem = undefined; showModal = false">
                            <i class="fa fa-close"></i> {{ $t('menu.close') }}
                        </b-button>
                    </div>

                </b-modal>

            </div>

        </div>
               
    </div>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts'
import ecTools from '@/echarts/echarts-tools'
import ecThemeDark from '@/echarts/theme/dark.json'
import AgriSpeech from '@/views/components/AgriSpeech';

export default {
    components: {
        AgriSpeech,
    },
    props:
    {
        chartID: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            default: function () { return {} }
        },
        showToolbox: {
            type: Boolean,
            default: true,
        },
        xAxisName: { type: String, },
        yAxisName: { type: String, },
        xAxisFormat: {
            type: String,
            default: 'MM/DD HH:mm',
        },
        theme: {
            type: String,
            default: 'light', // light, dark
        },
        extend: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            theChart: undefined,
            arrangedData: {},

            showModal: false,
            modalSize: 'lg',
            clickedItem: undefined,

            // data: {
            //     "final_date": "2020-10-07", 
            //     "final_pred_days": "103.2", 
            //     "start_date": "2020-06-25",
            //     "stage_date": [
            //         {
            //             "end_date": "2020-07-06", 
            //             "stage_name": "bbch_1_rice", 
            //             "start_date": "2020-06-25"
            //         }, 
            //         {
            //             "end_date": "2020-08-05", 
            //             "stage_name": "bbch_2_cereals", 
            //             "start_date": "2020-07-06"
            //         }, 
            //         {
            //             "end_date": "2020-08-24", 
            //             "stage_name": "panicle_formation", 
            //             "start_date": "2020-08-05"
            //         }, 
            //         {
            //             "end_date": "2020-09-01", 
            //             "stage_name": "bbch_4_cereals", 
            //             "start_date": "2020-08-24"
            //         }, 
            //         {
            //             "end_date": "2020-09-10", 
            //             "stage_name": "bbch_5_cereals", 
            //             "start_date": "2020-09-01"
            //         }, 
            //         {
            //             "end_date": "2020-10-07", 
            //             "stage_name": "ripening_cereals", 
            //             "start_date": "2020-09-10"
            //         },
            //     ],
            // }, // test data
        }
    },
    mounted ()
    {
        if ( this.theme == 'dark' )
        {
            echarts.registerTheme('dark', ecThemeDark)
            this.theChart = echarts.init(document.getElementById( this.chartID ), 'dark');
        }
        else
        {
            this.theChart = echarts.init(document.getElementById( this.chartID ));
        }
        this.drawChartPrepare();
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
            'screenWidth': state => state.system.screenWidth,
            'contentWidth': state => state.system.contentWidth,
        }),
    },
    watch: {
        // 偵測到 [ 語言 ] 變動就更新圖表
        language ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 資料 ] 變動就更新圖表
        data ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 視窗寬度 ] 變動就更新圖表
        screenWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
        // 偵測到 [ 版面寬度 ] 變動就更新圖表
        contentWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
    },
    methods: {

        arrange_DataSet ()
        {
            this.arrangedData = this.$tools.data.deepCopy_object( this.data )
            let _data = this.arrangedData
            let _stage_days = []
            let _colorList = ['#2c7e51', '#32a860', '#9fc514', '#e07d3b', '#dd4949', '#e2bb0e', '#b38d47', '#704141', '#b06f6f', '#d83d98', '#76256b', '#9d5aab', '#7c60ba', '#6771dd', '#1f8bd8', '#126578'];
            // let _colorList = ['#d5f06f', '#29e3c7', '#2ab3bd', '#b9a8f2', '#f9a7b3', '#ff8080', '#e46c0b'];

            /**
             * 處理生長期資料
             */
            let _stageSet = []
            if ( _data['stage_date'] )
            {
                _data['stage_date'].forEach( (_stage, _idx) => {

                    // 將設定寫回資料
                    _stage.color = _colorList[_idx]
                    _stage.stage_name = _stage.stage_name//_stage.name[ this.language ]
                    _stage.start_date = this.$moment( _stage.start_date ).format('YYYY-MM-DD')
                    _stage.end_date = this.$moment( _stage.end_date ).format('YYYY-MM-DD')
                    let _count_days = this.$tools.date.countDays( _stage.start_date, _stage.end_date )

                    // 產生 echart data 格式：[ 開始日期, 結束日期, y 軸高度, 生長期名稱, 顏色, 生長期日數, 是否錯開文字高度 ]
                    _stageSet.push({
                        value: [ _stage.start_date, _stage.end_date, 100, _stage.stage_name, _stage.color, _count_days, false ],
                        itemStyle: {
                            color: _stage.color,
                        },
                    })

                    // 將日期存進 List (不重複)，方便畫 x 軸的日期
                    if ( _stage_days.indexOf( _stage.start_date ) == -1 ) _stage_days.push( _stage.start_date )
                    if ( _stage_days.indexOf( _stage.end_date ) == -1 )   _stage_days.push( _stage.end_date )

                })
            }

            // 檢查日數是否夠寬，若日數過少，將文字高度錯開
            if ( _stageSet.length > 1 )
            {
                let _buff_width = 1
                // 先對第一個生長期做檢查
                if ( _stageSet[0].value[5] < _stageSet[0].value[3].length + _buff_width ) _stageSet[0].value[6] = true

                for (let i=1; i<_stageSet.length; i++)
                {
                    // 如果自己這格日數太小就錯開高度
                    if ( _stageSet[i].value[5] < _stageSet[i].value[3].length + _buff_width ) _stageSet[i].value[6] = ! ( _stageSet[i-1].value[6] )
                }
            }

            /**
             * 處理時間軸最大最小值
             */ 
            let _min_date, _max_date;
            if ( this.extend )
            {
                _min_date = this.$moment( _data.start_date ).add(-5, 'days').format('YYYY-MM-DD')  // 考量種植前處理，min day 往前顯示 5 天
                _max_date = this.$moment( _data.final_date ).add(20, 'days').format('YYYY-MM-DD')  // 考量收成時間，max day 延長顯示 20 天
            }
            else
            {
                _min_date = this.$moment( _data.start_date ).add(-2, 'days').format('YYYY-MM-DD')
                _max_date = this.$moment( _data.final_date ).add( 2, 'days').format('YYYY-MM-DD')
            }

            return {
                stage: _stageSet,

                stage_days: _stage_days,
                
                min_date: _min_date,
                max_date: _max_date,
            }
        },

        drawChartPrepare ()
        {
            // if (this.data && this.data.length > 0) {

                this.drawChart( this.theChart,
                                this.data,
                                this.showToolbox,
                                [ this.xAxisName, this.yAxisName ] );
            // }
        },
        
        drawChart ( chart,
                    _data,
                    _showToolbox,
                    _axisName )
        {
            let _this = this;
            let _grid_L = 30;
            let _grid_R = 40;

            let _xAxisName = ( _axisName[0] ? this.$t('u.'+_axisName[0]) : '');
            let _yAxisName = ( _axisName[1] ? this.$t('u.'+_axisName[1]) : '' );

            let _chartData = this.arrange_DataSet()
            let _stageSet = _chartData.stage
            let _stage_days = _chartData.stage_days;


            let option = {
                // title: {
                //     text: '生長期栽種紀錄',
                //     left: 'center',
                // },
                tooltip: {
                    position: 'inside',
                    backgroundColor: 'rgba(245, 245, 245, 0.9)',
                    borderWidth: 1,
                    borderColor: '#ccc',
                    padding: 10,
                    textStyle: {
                        color: '#000'
                    },
                    formatter: function (params) {
                        // console.log( params )
                        let _stageInfo = ''


                        let _createTooltip = function (_data, is_array = false) {
                            // console.log( _data )
                            
                            if ( _data.seriesName == 'growth_period' ) // stage
                            {
                                let _is_first = false
                                if ( _stageInfo == '' ) _is_first = true

                                _stageInfo += `<i class="fa fa-circle" style="color:${ _data.color }"></i>
                                ${ _data.name }<br>
                                ${ _this.$t('menu.range') }：${ _data.value[0] } - ${ _data.value[1] }
                                `

                                if ( _is_first && is_array ) _stageInfo += '<br><br>'
                            }
                            
                        }

                        if ( Array.isArray( params ) )
                        {
                            params.forEach( _data => {
                                _createTooltip( _data, true )
                            })
                        }
                        else
                        {
                            _createTooltip( params )
                        }

                        return _stageInfo
                    },
                },
                // dataZoom: [
                //     {
                //         show: true,
                //         // xAxisIndex: [0],//, 1, 2],
                //         type: 'slider',
                //         bottom: 5,
                //         left: 130,
                //         right: '20%',
                //         handleSize: '130%',
                //         handleIcon: 'image://' + this.$config.getAssetsURL('img/brand/AgriChartSymbol03.png'),
                //         backgroundColor: 'rgba( 153, 255, 102, 0.3 )',
                //         fillerColor: 'rgba( 102, 204, 0, 0.35 )',
                //         labelFormatter: function (value, valueStr) {
                //             return _this.$moment(value).format('MM/DD') + '\n' + _this.$moment(value).format('YYYY')
                //         },
                //     },
                // ],
                grid: [
                    {
                        id: 0,
                        top: '10%',
                        left:  _grid_L,
                        right: _grid_R,
                        height: '60%',
                    },
                ],
                xAxis: [
                    {
                        gridIndex: 0,
                        type: 'time',
                        boundaryGap: 0,
                        min: _chartData.min_date,
                        max: _chartData.max_date,
                        interval: 3600 * 24 * 1000, // 切分為每天一格
                        axisLabel: {
                            show: true,
                            interval: 0,
                            fontSize: 12,
                            formatter: function (value){
                                // console.log( value )
                                let _date = _this.$moment(value).format('YYYY-MM-DD')
                                // console.log( _date )
                                // console.log( _stage_days.indexOf( _date ) )
                                if ( _stage_days.indexOf( _date ) != -1 )
                                {
                                    return _this.$moment(_date).format('MM/DD') + '\n' + _this.$moment(_date).format('YYYY')
                                }
                                return ''
                            },
                        },
                        axisTick: { show: false },
                        splitLine: { show: false },
                    },
                ],
                yAxis: [
                    {
                        gridIndex: 0,
                        name: '阿龜生長期',
                        show: false,
                    },
                ],
                series: [
                    {
                        type: 'custom',
                        name: 'growth_period',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        renderItem: this.render_Stages,
                        label: {
                            show: true,
                            fontSize: 13.5,
                            color: 'auto',//'#000',
                            // textBorderColor: 'rgba(255,255,255,0.8)',
                            // textBorderWidth: 3,
                            position: 'top',//'inside',
                            formatter: function (params) {
                                // console.log( params )
                                // let _name = ( _this.screenWidth > 800 ? params.name : params.name.slice(0,2) )
                                let _name = params.name
                                
                                return _name + ( params.value[6] ? '\n' : '' )
                            },
                        },
                        dimensions: ['start date', 'end date', null, 'stage', 'color', 'count days'],
                        encode: {
                            x: [0, 1],
                            y: 2,
                            tooltip: [0, 1, 3],
                            itemName: 3,
                            value: 3,
                        },
                        data: _stageSet,
                        animation: true,
                        animationDuration: 5000,
                        animationDelay: function (idx) { return idx * 10; },
                    },
                ]
            };
            chart.setOption(option);

            chart.on('click', function (params) {
                // console.log( params )
                // console.log( params.dataIndex )
            //    _this.click_Chart(params)
            });
        },

        click_Chart (params) {
            if ( params.seriesName == 'growth_period' )
            {
                this.clickedItem = {
                    itemType: 'growth_period',
                    data: this.arrangedData['growth_period'][ params.dataIndex ],
                }
                this.modalSize = 'md'
                this.showModal = true
            }
            else
            {
                this.clickedItem = undefined
            }
        },

        render_Stages (params, api) {
            let yValue = api.value(2);
            let start = api.coord([api.value(0), yValue]);
            let size = api.size([api.value(1) - api.value(0), yValue]);
            let style = api.style();

            let yMin = 45

            return {
                type: 'rect',
                shape: {
                    x: start[0],
                    y: yMin + 5,//start[1],
                    width: size[0],
                    height: size[1] - yMin,
                },
                style: style,
            };
        },
      
    },
}
</script>

<style lang="scss" scoped>

.chart
{
    width: 100%;
    min-width: 600px;
    height: 120px;//170px;
}

.info-datazoom
{
    margin-top: -42px;
    margin-bottom: 20px;
    margin-left: 10px;
    // color: #1a8a50;

    .info-text {
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
    }
}

.date-time
{
    display: inline-block;
    vertical-align: middle;
    margin-right: 15px;
    font-size: 1.2rem !important;
}
.log-icon
{
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    font-size: 1.5rem;
    width: 37px;
    height: 37px;
    // background-color: red;
    border-radius: 20px;
    border: 3px solid #90ba2e;
    padding-left: 5px;
}
.log-info-block
{
    display: inline-block;
    padding: 7px 15px;
    font-size: 1.2rem !important;
}

.modal-pic
{
    width: 100%;
    height: 50vh;
    border-radius: 3px;
    margin-bottom: 10px;
}

// Speech Bubble
$speech-bubble-bg-color: #d1e674;
.speech-bubble
{
	// layout
    position: relative;
    margin: 10px;
    white-space: normal !important;
	
    // looks
    color: #2c2c2c;
	background-color: $speech-bubble-bg-color;
	padding: 1.125rem 1.5rem;
	font-size: 1.2rem;
	border-radius: 8px;
    // box-shadow:	0 0.125rem 0.5rem rgba(0, 0, 0, .3), 0 0.0625rem 0.125rem rgba(0, 0, 0, .2);
}
.speech-bubble::before
{
	// layout
	content: '';
	position: absolute;
	width: 0;
	height: 0;
	bottom: 100%;
	left: 1.2rem; // offset should move with padding of parent
	border: .75rem solid transparent;
	border-top: none;

	// looks
	border-bottom-color: $speech-bubble-bg-color;
	// filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, .1));
}


</style>